const domain = process.env.REACT_APP_API_BASE_URL;

// Auth
export const loginUrl = `${domain}/user/login`;
export const userExistUrl = `${domain}/user/exist`;
export const registerUrl = `${domain}/user/register`;
export const generateOtpUrl = `${domain}/user/generate-otp`;
export const profileUrl = `${domain}/user/profile`;
export const userPermissionUrl = `${domain}/user/permission`;
export const changePasswordUrl = `${domain}/user/change-password`;
export const resetPaaswordUrl = `${domain}/user/reset-password`;
export const logOutUrl = `${domain}/user/logout`;


// Schedule
export const scheduleUrl = `${domain}/schedule`;

// Global
export const bankUrl = `${domain}/bank`;
export const branchUrl = `${domain}/branch`;

// Homework
export const getCoachHomeworkUrl = `${domain}/homework/coach`;
export const getHomeworkStudentsUrl = `${domain}/homework/coach/get-students`;
export const getHomeworkDetailsUrl = `${domain}/homework`;
export const updateHomeworkUrl = `${domain}/homework/update`;
export const createHomeworkUrl = `${domain}/homework/create/`;
export const getHomeworkByStudentUrl = `${domain}/homework/student`;
export const markSubmissionSeenUrl = `${domain}/homework/coach/mark-submission-seen/`;
export const rateHomeworkUrl = `${domain}/homework/rate/`;

// Inbox
export const getNotificationListUrl = `${domain}/notification`;
export const readNotificationUrl = `${domain}/notification/seen`;

// Clock
export const getClockHistoryUrl = `${domain}/coach/clock`;
export const getClockDetailUrl = `${domain}/coach/clock/view`;
export const getLatestClockStatusUrl = `${domain}/coach/clock/latest`;
export const clockInUrl = `${domain}/coach/clock/in`;
